<template lang="pug">
    article#registroDeDiploma
        Banner(nomePagina="Registro de Diploma")
        Conteudo
        Inscricao
</template>

<script>
import Banner from '@components/BannerTemplates/BannerTemplates.vue'
import Conteudo from '@sections/RegistroDeDiploma/Conteudo/Conteudo.vue'
import Inscricao from '@components/Inscricao/Inscricao.vue'

import pagina from '@/mixins/pagina'

export default {
    name: "view-registro-de-diploma",
    components: {
        Banner, 
        Conteudo,
        Inscricao
    },
    mixins: [
        pagina
    ],
}
</script>

<style lang="stylus" scoped src="./RegistroDeDiploma.styl"></style>